import { Text, View } from "@react-pdf/renderer";
import React from "react";

export interface DocumentDetailSubSectionProps
  extends React.HTMLAttributes<HTMLElement> {
  title?: string;
  gap?: number;
}

const DocumentDetailSubSection = ({
  title,
  gap,
  children,
}: DocumentDetailSubSectionProps) => {
  return (
    <View
      style={{
        marginTop: "8mm",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {title && (
        <View
          style={{
            height: "15mm",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            borderBottom: "0.5mm solid #6D757F",
          }}
        >
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
              fontWeight: 700,
            }}
          >
            {title}
          </Text>
        </View>
      )}

      <View
        style={{
          display: "flex",
          flexDirection: "column",
          gap: gap || "2.6mm",
        }}
      >
        {children}
      </View>
    </View>
  );
};

export default DocumentDetailSubSection;
